package link.erpango.quip.data.db.entities

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import link.erpango.quip.db.QuipDb
import link.erpango.quip.domain.entities.DUser
import link.erpango.quip.utils.DatetimeUtils
import linkerpangoquipdb.User_table
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import app.cash.sqldelight.coroutines.mapToOneOrNull
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull
import kotlin.coroutines.CoroutineContext

class UserDAO(
    private val db: QuipDb
): IUserTable {
    override suspend fun insertUser(
        id: String,
        email: String,
        name: String?,
        avatar: String?,
    ) {
        if (db.userQueries.select(id).awaitAsOneOrNull() != null) {
            updateUser(id, email, name, avatar)
        } else {
            db.userQueries.insert(
                id = id,
                email = email,
                name = name,
                avatar = avatar,
                updated_at = DatetimeUtils.currentTimeMillis()
            )
        }
    }

    override fun observeUser(coroutineContext: CoroutineContext): Flow<DUser?>? {
        return db.authQueries.selectLastUserId()
            .asFlow()
            .mapToOneOrNull(coroutineContext)
            .flatMapLatest { lastUser ->
                if (lastUser != null) {
                    db.userQueries.select(lastUser.user_id)
                        .asFlow()
                        .mapToList(coroutineContext)
                        .map { it.firstOrNull()?.toDUser() }
                } else {
                    flowOf(null)
                }
            }
    }

    override suspend fun select(id: String): DUser? {
        return db.userQueries.select(id).awaitAsOneOrNull()?.toDUser()
    }

    override suspend fun selectEmail(id: String): String? {
        return db.userQueries.select(id).awaitAsOneOrNull()?.email
    }

    override suspend fun updateUser(id: String, email: String, name: String?, avatar: String?) {
        db.userQueries.update(
            email = email,
            name = name,
            avatar = avatar,
            id = id,
            updated_at = DatetimeUtils.currentTimeMillis()
        )
    }

    override suspend fun deleteUser(id: String) {
        db.userQueries.delete(id)
    }

    override suspend fun setLoggedUser(id: String) {
        db.userQueries.select(id).awaitAsOneOrNull()?.let {
            db.userQueries.update(
                email = it.email,
                name = it.name,
                avatar = it.avatar,
                id = it.id,
                updated_at = DatetimeUtils.currentTimeMillis()
            )
        }
    }

    override suspend fun selectCurrentUser(): DUser? {
        return db.userQueries.selectCurrentUser().awaitAsOneOrNull()?.toDUser()
    }


}

fun User_table.toDUser(): DUser {
    return DUser(
        id = id,
        email = email,
        name = name,
        avatar = avatar
    )
}


